import {inject} from '@angular/core';
import {ResolveFn} from '@angular/router';
import {Store} from '@ngxs/store';
import {take} from 'rxjs/operators';
import {UserService} from '../services/user.service';
import {User} from '../../models/user.model';
import {UpdateAccount} from 'src/app/shared/state/session.actions';

/**
 * Loads the account (with its Logto permissions) from /api/user once the user is signed in to Logto.
 */
export const userResolver: ResolveFn<User> = () => {
  const userService = inject(UserService);
  const store = inject(Store);

  if (!userService.getSnapshot()) {
    store.dispatch(new UpdateAccount());
  }

  return userService.get().pipe(take(1));
};
